export const stepsDescription = [
  'booking.step1_typeOfDoctor',
  'booking.step2_doctor',
  'booking.step3_doctorDetails',
  'booking.step4_selectDate',
  'booking.step5_healthProblem',
  'booking.step6_readBeforeConfirming',
  'booking.step_payment',
];
